import React, { useMemo } from 'react';
import {
  ListItemIcon,
  ListItemText,
  Link,
  MenuItem,
  Button
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';
import { useFeatureFlag } from 'modules/common/hooks';

const useStyles = makeStyles((theme) => ({
  link: {
    textDecoration: 'none',
    color: theme.palette.text.primary
  },
  button: {
    color: theme.palette.text.primary,
    textTransform: 'none',
    borderRadius: theme.spacing(0),
    '&:focus': {
      backgroundColor: theme.palette.table.border
    },
    '&:hover': {
      backgroundColor: theme.palette.grey[100]
    },
    padding: theme.spacing(0.5, 4, 0.5, 0)
  },
  menuItem: {
    width: '100%',
    '&:hover': {
      backgroundColor: theme.palette.grey[100]
    }
  }
}));

export const DownloadMenuItem = (): JSX.Element => {
  const linkClasses = useStyles();
  const isTiwVpatEnabled = useFeatureFlag('isTiwVpatEnabled');

  const downloadMeanItem = useMemo(() => {
    return (
      <MenuItem data-testid="download-menu" className={linkClasses.menuItem}>
        <ListItemIcon>
          <DownloadIcon data-testid={'download-icon'} />
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage id="appMenu.desktopApp" />
        </ListItemText>
      </MenuItem>
    );
  }, [linkClasses]);

  return (
    <>
      {isTiwVpatEnabled ? (
        <Button
          href={'/download'}
          target="_blank"
          data-testid="download-button"
          variant="text"
          className={linkClasses.button}
          disableFocusRipple
        >
          {downloadMeanItem}
        </Button>
      ) : (
        <Link
          href={'/download'}
          target="_blank"
          color="primary"
          underline="none"
          data-testid="download-menu-item"
          className={linkClasses.link}
        >
          {downloadMeanItem}
        </Link>
      )}
    </>
  );
};
